var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VApp",
    { staticClass: "v-app base", attrs: { dark: _vm.isDark } },
    [
      _c("NotificationCenter"),
      _vm._v(" "),
      _c("KmTooltipPortal"),
      _vm._v(" "),
      [
        _c("SupportPopup"),
        _vm._v(" "),
        _c("NavigationPortal"),
        _vm._v(" "),
        _c(
          "KmModal",
          {
            attrs: { noClickAnimation: "", persistent: "", maxWidth: "400" },
            model: {
              value: _vm.activatePM2,
              callback: function ($$v) {
                _vm.activatePM2 = $$v
              },
              expression: "activatePM2",
            },
          },
          [
            _c("PricingTable", {
              attrs: { upgrade: true, handleSubscribe: _vm.subscribe },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.canUpgrade && _vm.$store.getters.currentBucket
          ? _c("UpgradeStepper", {
              attrs: {
                isOpen: _vm.upgradeStepperOpen,
                plan: _vm.plan,
                isTrial: _vm.isTrial,
                handleBack: _vm.closeStepper,
              },
              on: {
                close: function ($event) {
                  _vm.upgradeStepperOpen = false
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "app-content flex-col flex-1" },
          [
            _c("Header", {
              attrs: {
                mobileNavOpen: _vm.isMobileNavOpen,
                haveNavBar: _vm.haveNavBar,
              },
              on: { toggleSidebar: _vm.toggleMobileNav },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-row flex-1" },
              [
                _vm.haveNavBar
                  ? _c("BucketNavBar", {
                      attrs: { mobileOpen: _vm.isMobileNavOpen },
                      on: {
                        "update:mobileOpen": function ($event) {
                          _vm.isMobileNavOpen = $event
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-1 flex-col page-top-and-content" },
                  [
                    _c("PageTop"),
                    _vm._v(" "),
                    !_vm.isPageLoading
                      ? _c("RouterView")
                      : _c(
                          "div",
                          { staticClass: "route-loader" },
                          [_c("LoadingSpinner")],
                          1
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }